import { useSearchParams } from "@remix-run/react";

export default function useLandingUrl() {
  const [searchParams] = useSearchParams();
  const authUrl = new URL(`${process.env.DASHBOARD_URL!}/auth`);

  const redirectUrl = searchParams.get("redirect_url");
  // we redirect to Clerk's oauth callback
  if (
    redirectUrl &&
    new URL(redirectUrl, process.env.DASHBOARD_URL!).origin === new URL(process.env.CLERK_OAUTH_DOMAIN!).origin
  ) {
    return redirectUrl;
  }

  if (searchParams.has("__clerk_ticket")) {
    authUrl.searchParams.set("__clerk_ticket", searchParams.get("__clerk_ticket") as string);
  }

  if (redirectUrl) {
    authUrl.searchParams.set(
      "redirect_url",
      // DO NOT REMOVE THIS:
      // extra encoding is necessary because Clerk's sign in flow (/oauth_callback) doesn't encodes it correctly
      encodeURIComponent(redirectUrl),
    );
  }

  return authUrl.toString();
}
